export default "__VITE_ASSET__hnI36fgISA9mw3EEmkcdcA__"